import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { atLeastOneLang } from './../../shared/validators/langField.validator';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { EntityService } from './../../shared/services/entity.service';
import { Textarea } from './../../models/editors/textarea.model';
import { Designbox } from './../../models/designboxes/designboxes.model';
import { Textbox } from './../../models/editors/textbox.model';

@Component({
  selector: 'swb-designbox-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class DesignboxDetailComponent extends FormDetailBase<Designbox> implements OnInit {
  public url = 'designboxes';
  protected _redirect = './pages';

  public entity = new Designbox({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'link',
        label: 'Odkaz (volitelné)',
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        label: 'Obsah boxu',
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: 'designboxes'
      }),
      new Contained({
        key: 'file_id',
        label: 'Obrázek',
        imgOnly: true,
        entity: this.entity.file,
        upload: true
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _entityService: EntityService
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    if (this._route.outlet === 'modal-form') {
      this.isModal = true;
      this._redirect = undefined;
      this._saveCallback = this._saveCallback = (response) => {
        const item = { ...response }.data;
        this._entityService.setChosenEntities([item], 'designboxes');
        this._closeCallback();
      };
      this._closeCallback = () => {
        this._router.navigate([{ outlets: { 'modal-form': null } }], {
          relativeTo: this._route.parent
        });
      };
      this._id = undefined; // TODO: better?
      window.scrollTo(0, 0);
    }

    this._getEntity();

  }

}
